import CityPageTemplate from "../city-template/CityPageTemplate";
import { bellinghamConfig } from "./data";

export default function BellinghamPage() {
  return <CityPageTemplate config={bellinghamConfig} />;
}